import { ReactElement } from 'react';

import Post1 from '../Posts/Post1';
import Post2 from '../Posts/Post2';
import Post3 from '../Posts/Post3';
import Post4 from '../Posts/Post4';

interface IProps {
  id: number;
}

// TODO:
// Using a PostPage as a switch router
// the best approach here is to use a reusable Post component
// but since each Post may contain a different html structure
// the code refactor will require additional time
// So currently we're using a switch flow with separate Post article
const PostPage = ({ id }: IProps): ReactElement => {
  const render = () => {
    switch (id) {
      case 1:
        return <Post1 />;
      case 2:
        return <Post2 />;
      case 3:
        return <Post3 />;
      case 4:
        return <Post4 />;
      default:
        return null;
    }
  };

  return render();
};

export default PostPage;
